import React from 'react';
import styled from 'styled-components';
import {Blocks} from 'react-loader-spinner';

const StyledLoading = styled.div`
    min-height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Loading = () => {
    return (
        <StyledLoading>
            <Blocks
                height="100"
                width="100"
                color="#2e8b57"
                ariaLabel="blocks-loading"
                wrapperClass="blocks-wrapper"
            />
        </StyledLoading>
    )
}
